import { render, staticRenderFns } from "./BoxCapacityReadOnly.vue?vue&type=template&id=5cd38a4e&"
import script from "./BoxCapacityReadOnly.vue?vue&type=script&lang=js&"
export * from "./BoxCapacityReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports